/**
 * @file 复制按钮
 * @author sunyingying01
 */
import {useCallback} from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import {Tooltip} from 'antd';

import s from './index.module.less';

export interface ICopyButton {
    /** 待复制文案 */
    text: string;
    /** 按钮名称 */
    buttonName?: string;
    /** 复制成功回调 */
    onCopyCallbacks?: () => void;
    /** 复制svgr组件 */
    copyIcon: React.ReactElement<{className?: string}>;
    /** 是否复制原始字符串 */
    isOriginStr?: boolean;
    /** 是否禁用 */
    isDisabled?: boolean;
}

export function CopyButton(props: ICopyButton) {
    const {text, buttonName, onCopyCallbacks, copyIcon} = props;

    const getPureText = useCallback(
        (text: string) => {
            if (!text) {
                return '';
            }

            if (props.isOriginStr) {
                return text;
            }

            return text.replace(/<sup[^>]*>.*?<\/sup>/g, '').replace(/<[^>]*>/g, '');
        },
        []
    );

    const handleOnCopy = useCallback(
        (text: string, result: boolean) => {
            if (props.isDisabled) {
                return;
            }
            if (result && onCopyCallbacks) {
                onCopyCallbacks();
            }
        },
        [onCopyCallbacks, props.isDisabled]
    );

    return (
        <div className={s.copyContainer}>
            <CopyToClipboard
                text={getPureText(text)}
                onCopy={handleOnCopy}
            >
                <Tooltip title="复制">
                    <div className={s.copyButton}>
                        {copyIcon}
                        {buttonName ? (
                            <span className={s.buttonName}>{buttonName}</span>
                        ) : undefined}
                    </div>
                </Tooltip>

            </CopyToClipboard>
        </div>
    );
}
